module.exports = __webpack_public_path__ + "img/sa_police_logo.8ee4946f.png";